import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { useApptekster } from '../../contexts/ApptekstContext';
import {
    AktivSakStatus,
    DineSkiltSakStatus,
    SakStatus,
    trekkSoknad,
} from '../../utils/api';
import { useApi } from '../../hooks/useApi';
import { HotjarMaskert } from '../../components/HotjarMaskert';
import { Paragraph } from '../../components/Paragraph';

import './GodkjennTegnkombinasjonSteg.scss';
import { GodtaVilkarSkjema } from '../../components/GodtaVilkarSkjema';
import { PakrevdFelt } from '../../components/PakrevdFelt';
import { SVVButton } from '@komponentkassen/svv-button';

type GodkjennTegnkombinasjonStegProps = {
    sakStatus: SakStatus;
    soknadId: number;
    tegnkombinasjon: string;
    datoStatusEndret: string;
};

export const GodkjennTegnkombinasjonSteg: React.FC<
    GodkjennTegnkombinasjonStegProps
> = ({ sakStatus, tegnkombinasjon, datoStatusEndret, soknadId }) => {
    const t = useApptekster();
    const navigate = useNavigate();
    const [trekkeSoknad, setTrekkeSoknad] = useState(false);

    const { hent, data, laster } = useApi(trekkSoknad, { id: 'trekkSoknad' });

    const visLaster = laster || data?.ok;

    const bekreftelsestekst = `${t(
        'personlig-kjennemerke.status.godkjenn.trekk-soknad.vilkar.del1',
    )} ${tegnkombinasjon} ${t(
        'personlig-kjennemerke.status.godkjenn.trekk-soknad.vilkar.del2',
    )}`;

    switch (sakStatus) {
        case AktivSakStatus.MOTTATT:
        case AktivSakStatus.UNDER_BEHANDLING:
            return (
                <li className="statusliste__steg aktiv">
                    <h3 className="svv-h5 svv-h5--spacing">
                        {t(
                            'personlig-kjennemerke.status.godkjenn.soknad-sendt.info',
                        )}{' '}
                        <HotjarMaskert>{datoStatusEndret}</HotjarMaskert>
                    </h3>
                    {!trekkeSoknad && (
                        <>
                            <Paragraph>
                                {t(
                                    'personlig-kjennemerke.status.godkjenn.info.del1',
                                )}{' '}
                                <HotjarMaskert>{tegnkombinasjon}</HotjarMaskert>
                                {t(
                                    'personlig-kjennemerke.status.godkjenn.info.del2',
                                )}
                            </Paragraph>
                            <SVVButton
                                color={'secondary'}
                                onClick={() => setTrekkeSoknad(true)}
                            >
                                {t(
                                    'personlig-kjennemerke.status.godkjenn.trekk-soknad',
                                )}
                            </SVVButton>
                        </>
                    )}
                    {trekkeSoknad && (
                        <div className="trekk-soknad">
                            <PakrevdFelt className="spacing-bottom--xxsmall" />
                            <GodtaVilkarSkjema
                                handlingsknapp={t(
                                    'personlig-kjennemerke.status.godkjenn.trekk-soknad',
                                )}
                                avbrytKnapp={() => setTrekkeSoknad(false)}
                                bekreftelseslabel={t(
                                    'personlig-kjennemerke.trekk-soknad.sjekkboks.label',
                                )}
                                bekreftelsestekst={bekreftelsestekst}
                                onSubmit={() => {
                                    hent(soknadId);
                                    navigate(-1);
                                }}
                                laster={!!visLaster}
                            />
                        </div>
                    )}
                </li>
            );
        case AktivSakStatus.INNVILGET:
        case AktivSakStatus.BETALT:
        case AktivSakStatus.SKILT_BESTILT:
        case AktivSakStatus.SKILT_BESTILT_BRUKER:
        case AktivSakStatus.SKILT_MOTTATT:
        case DineSkiltSakStatus.SKILT_UTLEVERT:
        case DineSkiltSakStatus.KNYTTET:
            return (
                <li className="statusliste__steg fullfort">
                    <h3 className="svv-h5 svv-h5--spacing">
                        {t(
                            'personlig-kjennemerke.status.godkjenn.godkjent.del1',
                        )}{' '}
                        <HotjarMaskert>{tegnkombinasjon}</HotjarMaskert>{' '}
                        {t(
                            'personlig-kjennemerke.status.godkjenn.godkjent.del2',
                        )}
                    </h3>
                    <p>
                        {t(
                            'personlig-kjennemerke.status.godkjenn.godkjent.info',
                        )}
                    </p>
                </li>
            );
        default:
            return <></>;
    }
};
